import { TermScheduleFlags } from '../services/term_schedule_flags';
import { ISection, ISectionTime, ITermCourse } from '../../../interfaces/scheduler_interfaces';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { ScheduledSectionStatus } from '../types/scheduled_section_status_enum';
const _4 = require('lodash4');
const moment = require('moment');
import { SchedulerModel } from '../models/scheduler_model';

export class ScheduledSectionTileServant {
  constructor(
    private ngTermScheduleFlags: TermScheduleFlags,
    private getCSSClassForString: any,
    private ngSectionsDatasource: ISectionsDatasource,
    private ngSchedulerModel: SchedulerModel
  ) {}

  getCourseLocationsString(section: ISection) {
    return _4.map(section._section_times, (sectionTime: ISectionTime) => {
      return {
        campus: `${sectionTime._location.campus_name}`,
        address: `${sectionTime._location.address}`
      };
    });
  }

  getLastDayToDrop(section: ISection): string {
    const customTextForLastDayToDrop = _4.get(
      this.ngSchedulerModel.read(),
      'customtext.LAST_DAY_TO_DROP.text',
      'Last day to drop:'
    );
    return section.drop_end_dt
      ? `${customTextForLastDayToDrop} ${moment(section.drop_end_dt, 'YYYY-MM-DD').format('MMM Do YYYY')}`
      : ``;
  }

  getLastDayToWithdraw(section: ISection): string {
    const customTextForWithdraw = 'Last day to Withdraw:';
    return section.withdraw_end_dt
      ? `${customTextForWithdraw} ${moment(section.withdraw_end_dt, 'YYYY-MM-DD').format('MMM Do YYYY')}`
      : ``;
  }

  getTileColor(section: ISection): string {
    const courseNk = _4.get(section, '_course.nk', '');
    return section.status === ScheduledSectionStatus.WAITLISTED
      ? 'clr-gray_30-bdr'
      : this.getCSSClassForString(courseNk, 'bdr');
  }

  isWaitlistEnabled() {
    return this.ngTermScheduleFlags.isWaitlistEnabled();
  }

  isWithdrawEnabled() {
    return this.ngTermScheduleFlags.isWithdrawEnabled();
  }

  getCourseSectionsById(courseId: number) {
    return _4.filter(this.ngSectionsDatasource.read(), (section: ISection) => section.course === courseId);
  }

  getInstructorsForCourse(course: ITermCourse): string {
    const instructors = _4
      .uniq(_4.map(this.getCourseSectionsById(course.id), (section: ISection) => section.instructor_name))
      .join(', ');
    return instructors;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/servants/scheduled_section_tile_servant.ts